/**
 * /logs Cash-only / Cash-In / Cash-Out — shared with Reporting and Metrics
 * so the same filters persist across those pages.
 */

export type ActivityLogsCashFilters = {
  /** Cash-only off: include N/A / non-cash rows. */
  allItems: boolean,
  cashIn: boolean,
  cashOut: boolean,
};

export const DEFAULT_ACTIVITY_LOGS_CASH_FILTERS: ActivityLogsCashFilters = {
  allItems: true,
  cashIn: true,
  cashOut: true,
};

/** Map ActivityLogs cash toggles onto Metrics +/- / both. */
export const activityLogsCashFiltersToFlowType = (
  filters: ActivityLogsCashFilters,
): '+' | '-' | 'both' => {
  if (!filters.allItems && filters.cashIn && !filters.cashOut) return '+';
  if (!filters.allItems && filters.cashOut && !filters.cashIn) return '-';
  return 'both';
};

/** Metrics +/- / both → ActivityLogs cash toggles (both = Cash-only off). */
export const flowTypeToActivityLogsCashFilters = (
  flow: '+' | '-' | 'both',
): ActivityLogsCashFilters => {
  if (flow === '+') return { allItems: false, cashIn: true, cashOut: false };
  if (flow === '-') return { allItems: false, cashIn: false, cashOut: true };
  return { ...DEFAULT_ACTIVITY_LOGS_CASH_FILTERS };
};
